var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2204 21.3928C8.26522 20.9372 8.33245 20.4815 8.42955 20.0109V19.996C8.41461 19.996 8.39967 19.996 8.3922 20.0035C7.705 20.0707 6.62191 20.1529 5.8152 20.2574C4.41093 20.4442 3.13362 20.6309 3.02904 20.7579C2.73773 21.1015 4.66487 21.3555 7.59289 21.3928L8.2204 21.3928Z",
    fill: "url(#paint0_linear_896_31995)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9732 8.00747C18.3494 8.00747 13.7856 10.6218 10.9695 14.4538C10.9695 14.4538 4.41125 14.9244 4.06752 15.507C3.03673 17.4865 3.00684 20.8103 3.00684 20.8103V20.8028C3.0143 20.7879 3.02178 20.7729 3.02924 20.758C3.13382 20.631 4.41113 20.4443 5.8154 20.2575C6.61466 20.1529 7.7052 20.0708 8.3924 20.0036C8.40734 20.0036 8.41481 20.0036 8.42975 19.9961C10.708 19.772 15.0554 19.4583 17.5352 19.391C23.623 19.2267 28.874 19.2715 32.5191 19.4359C33.5798 13.0717 29.4118 8.00742 22.9729 8.00742L22.9732 8.00747Z",
    fill: "url(#paint1_linear_896_31995)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5262 19.4358C28.8885 19.2715 23.6375 19.2192 17.5422 19.391C15.0549 19.4582 10.7076 19.772 8.42941 19.9961C8.38459 20.25 8.30242 20.6683 8.2352 21.2136V21.2435C8.21279 21.4302 8.19785 21.617 8.18291 21.8037V21.8411C8.17544 22.0203 8.16797 22.1996 8.16797 22.3789C8.16797 22.4909 8.16797 22.603 8.17544 22.715C8.17544 22.8121 8.17544 22.9017 8.18291 22.9914C8.19037 23.1856 8.20531 23.3873 8.22025 23.5815C8.22772 23.6338 8.23519 23.6935 8.24266 23.7458C8.2576 23.8952 8.28001 24.0446 8.30242 24.194C8.30989 24.2537 8.32483 24.3135 8.3323 24.3732C8.3547 24.5152 8.38458 24.6571 8.41446 24.799C8.4294 24.8588 8.43687 24.9111 8.45181 24.9634C8.48916 25.1053 8.5265 25.2547 8.56385 25.3966C8.57132 25.419 8.57879 25.4414 8.58626 25.4713C10.8794 25.2472 13.6954 25.0306 17.0193 24.8961C17.0567 24.8961 18.4759 24.8438 18.4908 24.8438C21.5684 24.7467 28.5001 24.799 30.3749 24.8214C30.6737 24.8214 30.8605 24.8289 30.8605 24.8289C32.4365 24.8513 33.0789 24.8663 34.7149 24.9559C35.4693 24.9932 36.7242 25.0455 36.7914 25.2099V25.2173C36.7914 25.2248 36.7914 25.2248 36.7839 25.2323C37.8222 23.3126 37.8371 20.138 37.8371 20.138C37.8969 19.8616 35.9175 19.5927 32.5262 19.4358Z",
    fill: "url(#paint2_linear_896_31995)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.763 14.1326H32.1375C30.8601 10.4726 27.4688 8 22.9798 8C18.356 8 13.7922 10.6218 10.9761 14.4464C13.0003 14.2596 15.6447 14.1027 18.2364 14.058C18.7443 14.0505 19.7153 13.8413 20.2606 13.0346C21.2765 11.5257 22.2774 10.0019 23.6965 9.49397C23.7189 9.48649 23.7488 9.47156 23.7712 9.46409C25.9374 8.64991 28.7909 10.6591 30.763 14.1326Z",
    fill: "url(#paint3_linear_896_31995)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3741 24.829C28.4993 24.8141 21.575 24.7543 18.49 24.8514C18.4751 24.8514 17.0634 24.9037 17.0185 24.9037C13.6946 25.0382 10.8785 25.2473 8.58545 25.4788C9.7507 29.3481 13.2241 31.9997 17.8702 31.9997C22.7777 31.9997 27.6253 29.0492 30.3743 24.8288L30.3741 24.829Z",
    fill: "#E4002B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3737 24.829C27.6175 29.0494 22.7771 31.9999 17.8696 31.9999C15.6586 31.9999 13.7166 31.4024 12.1552 30.3566C10.4372 29.2063 9.18979 27.5107 8.57715 25.479C10.8703 25.255 13.6863 25.0383 17.0102 24.9039C17.055 24.9039 18.4743 24.8516 18.4817 24.8516C21.5742 24.7545 28.5059 24.8068 30.3732 24.8292L30.3737 24.829Z",
    fill: "url(#paint4_linear_896_31995)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3741 24.829C29.911 24.8215 29.1342 24.8215 28.1781 24.8141C25.9671 24.7991 22.7478 24.7917 20.4544 24.8141C19.9465 25.2249 19.3713 25.8374 19.1024 26.3901C17.3172 29.4078 16.6972 32.3657 11.1772 27.8542C11.1772 27.8542 10.2958 27.772 9.69824 27.8841C10.3033 28.8103 11.0801 29.6021 11.9914 30.2444C12.0586 30.2893 12.1184 30.3266 12.1632 30.3565C12.2678 30.4237 12.3649 30.4909 12.4695 30.5582C13.9708 31.4769 15.8008 31.9998 17.8701 31.9998C22.7776 31.9998 27.6251 29.0495 30.3741 24.829Z",
    fill: "url(#paint5_linear_896_31995)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7964 25.2098C36.7292 25.0455 35.4743 25.0007 34.7199 24.9559C33.0766 24.8662 32.4342 24.8513 30.8655 24.8289C30.8655 24.8289 30.6788 24.8289 30.38 24.8214C30.1036 25.2397 29.8123 25.643 29.4985 26.039C33.8308 25.912 36.6771 25.6057 36.7964 25.2098Z",
    fill: "url(#paint6_linear_896_31995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_896_31995",
    x1: 5.68673,
    y1: 20.2186,
    x2: 5.96393,
    y2: 21.7909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D85B13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#E57B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5447,
    stopColor: "#EF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7964,
    stopColor: "#F5A304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_896_31995",
    x1: 10.1539,
    y1: 9.41556,
    x2: 26.3516,
    y2: 25.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0154,
    stopColor: "#FCC94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1364,
    stopColor: "#F7B01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1963,
    stopColor: "#F5A709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4906,
    stopColor: "#F5A509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#F39D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7728,
    stopColor: "#F28F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8806,
    stopColor: "#EF7C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9766,
    stopColor: "#EB630B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_896_31995",
    x1: 9.27656,
    y1: 17.6887,
    x2: 36.0527,
    y2: 27.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    stopColor: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1074,
    stopColor: "#DFDEDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1648,
    stopColor: "#F1F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2241,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#FDFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6495,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7602,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#BAB9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A5A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_896_31995",
    x1: 12.8269,
    y1: 9.36024,
    x2: 31.4104,
    y2: 16.1239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859,
    stopColor: "#FDCC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1950A",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_896_31995",
    x1: 19.4841,
    y1: 32.0018,
    x2: 19.4841,
    y2: 24.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88181E",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4969,
    stopColor: "#B21829",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6534,
    stopColor: "#AA1827",
    stopOpacity: 0.3111
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8996,
    stopColor: "#931821",
    stopOpacity: 0.8004
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88181E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_896_31995",
    x1: 15.2716,
    y1: 32.7159,
    x2: 24.5346,
    y2: 20.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0123,
    stopColor: "#E20334",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0489,
    stopColor: "#DA0531",
    stopOpacity: 0.041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2059,
    stopColor: "#BB0E28",
    stopOpacity: 0.2166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3591,
    stopColor: "#A51421",
    stopOpacity: 0.388
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    stopColor: "#98181D",
    stopOpacity: 0.5519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#93191C",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95191D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_896_31995",
    x1: 33.1488,
    y1: 26.0419,
    x2: 33.1488,
    y2: 24.8273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006135,
    stopColor: "#D7D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#D0D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#BCBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7894,
    stopColor: "#9C9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer2);
export default __webpack_public_path__ + "static/media/offer_2.f76362360a2f448dd892e94e2bbb8d9a.svg";
export { ForwardRef as ReactComponent };